<ion-header>
  <ion-toolbar>
    <ion-title>Select participant</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="close()">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <ion-toolbar>
    <ion-searchbar placeholder="Search" type="text" (ionInput)="getItems($event)" [debounce]="250"></ion-searchbar>
  </ion-toolbar>

  <ion-list>
    @for (participant of participants(); track $index) {
      <ion-item button (click)="selectParticipant(participant)">
        <ion-label>{{participant.displayName}}</ion-label>
        <ion-button color="danger" (click)="deleteParticipant(participant._id)" fill="clear">
          @if (deletingParticipantId === participant._id) {
            <ion-spinner name="crescent"></ion-spinner>
          } @else {
            <ion-icon slot="icon-only" name="trash"></ion-icon>
          }
        </ion-button>
      </ion-item>
    }
  </ion-list>
</ion-content>